export default {
      id: "mail-usage",
      viewBox: "0 0 20 16",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#mail",
      toString: function () {
        return this.url;
      }
    }